// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"styles__checkbox__3Sq8C","label":"styles__label__jyc9J","box":"styles__box__wdrEF"};